

























import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import {
  UserOnboardingSteps,
  UserOnboardingStepKey
} from "@/shared/types";
import Logo from "@/shared/components/Logo.vue";
import { useUserStore } from "@/shared/store/user";
import { useWizardStore } from "@/employee/store/wizard";
import { useFdicStore } from "@/shared/store/fdic";
import Fdic from "@/shared/components/Fdic.vue";

@Component({
  components: {
    Logo,
    Fdic
  }
})
export default class HsaBankOnboardingHeader extends Vue {
  userStore = useUserStore();
  wizardStore = useWizardStore();
  fdicStore = useFdicStore();

  @Prop ()
  step: number;

  @Prop ()
  stepKey: "" | UserOnboardingStepKey;

  @Prop ()
  hideProgressIndicator: boolean;

  get isClaimAccountOnboarding (): boolean {
    return this.wizardStore.shownStatuses &&
      this.wizardStore.shownStatuses.some(s => s.step === UserOnboardingSteps.ClaimAccountTerms);
  }

  get selectedStepIndex (): number {
    if (this.stepKey) {
      return this.wizardStore.onboardingStepIndex(this.stepKey);
    }

    return this.step;
  }
}

